import { getTicketUserName } from './ticketViewHelper'

export const studentTicketStatuses = {
  pending: ['รอรับเรื่อง', 'Pending'],
  assigned: ['มอบหมายช่าง', 'Assign Technician'],
  in_progress: ['กำลังซ่อม', 'In progress'],
  done: ['ซ่อมเสร็จ รอประเมิน', 'Repaired · awaiting rating'],
  welldone: ['ประเมินแล้ว', 'Rated'],
  cancelled: ['ยกเลิก', 'Cancelled'],
}
export const isStudentTicketOpen = ticket => ['pending', 'assigned', 'in_progress'].includes(ticket.status)
export const isStudentTicketOverdue = (ticket, now = Date.now()) => isStudentTicketOpen(ticket) && Boolean(ticket.slaDeadline) && new Date(ticket.slaDeadline).getTime() < now
export const studentTicketBuilding = ticket => ticket.userPart?.locationType === 'outdoor' ? 'outdoor' : (ticket.userPart?.buildingLocation?.building?.BUILDINGCODE || '')
export const studentTicketAssignees = ticket => {
  const part = ticket.supervisorPart || {}
  const assignments = part.assignments || []
  const people = assignments.length
    ? assignments.filter(item => item.status !== 'rejected').map(item => item.assignee)
    : [part.assignedTechnician]
  return [...new Set(people.filter(Boolean).map(person => `${person.name || ''} ${person.surname || ''}`.trim()).filter(Boolean))].join(', ')
}

export const filterStudentTickets = (tickets, filters, now = Date.now()) => {
  const keyword = (filters.search || '').trim().toLocaleLowerCase()
  const from = filters.from ? new Date(`${filters.from}T00:00:00`).getTime() : null
  const until = filters.to ? new Date(`${filters.to}T00:00:00`) : null
  if (until) until.setDate(until.getDate() + 1)
  return tickets.filter(ticket => {
    const user = ticket.userPart || {}
    const date = new Date(user.dateTimeInformed || ticket.createdAt).getTime()
    if (from !== null && !(date >= from)) return false
    if (until && !(date < until.getTime())) return false
    if (filters.status && ticket.status !== filters.status) return false
    if (filters.building && studentTicketBuilding(ticket) !== filters.building) return false
    if (filters.job && (user.subCategory || user.otherCategoryText) !== filters.job) return false
    if (filters.tab === 'active' && !isStudentTicketOpen(ticket)) return false
    if (filters.tab === 'completed' && !['done', 'welldone'].includes(ticket.status)) return false
    if (filters.tab === 'cancelled' && ticket.status !== 'cancelled') return false
    if (filters.attention === 'overdue' && !isStudentTicketOverdue(ticket, now)) return false
    if (filters.attention === 'unrated' && ticket.status !== 'done') return false
    return !keyword || [ticket.ticketNumber, getTicketUserName(ticket), user.problemDetails, user.buildingLocation?.roomName, studentTicketBuilding(ticket), user.subCategory, user.otherCategoryText, studentTicketAssignees(ticket)]
      .some(value => String(value || '').toLocaleLowerCase().includes(keyword))
  })
}
